import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 *
 * 满足触发条件，则主动 finish 发送埋点
 * 触发条件： 1. onload  2. mousedown  3. lcp/fmp 完成
 *
 */
import lego from "../../../lego";
import { initBase } from "./base";
import { calcNetSpeed } from "./net-speed";
import { startPerformance } from "./performance";
import { waitTime } from "../../utils";
import FMPTiming from "./fmp";
var LOAD_MAX_FINAL_TIME_OUT = 20 * 1e3; // 10s 自动触发超时
// const NAVIGATOR_MAX_FINAL_TIME_OUT = 10 * 1e3
var timer;
// 触发发送机制
var waitTriggerTask = function waitTriggerTask(task) {
  return new Promise(function (resolve, reject) {
    try {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      var state = task.ctx.state;
      // pageload:
      // navigation:

      var curState = 'init';
      if (state === 'pageload') {
        timer = setTimeout(function () {
          timer = null;
          task.finishState = 'timeout';
          task.metrics['lcp'] = task.metrics['fmp'] = 10e3;
          resolve(true);
        }, LOAD_MAX_FINAL_TIME_OUT);
        if (curState === 'init') {
          if (document.readyState === 'complete') {
            curState = 'load';
          } else {
            window.addEventListener('load', function () {
              curState = 'load';
            });
          }
          var handleClick = /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var delayT;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    delayT = +new Date() - task.ctx.startTimestamp;
                    if (!(curState === 'load' && delayT > 1000)) {
                      _context.next = 10;
                      break;
                    }
                    _context.next = 4;
                    return waitTime(10);
                  case 4:
                    task.finishState = curState = 'mousedown';
                    //
                    window.removeEventListener('mousedown', handleClick);
                    window.removeEventListener('keydown', handleClick);
                    clearTimeout(timer);
                    timer = null;
                    resolve(true);
                  case 10:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function handleClick() {
              return _ref.apply(this, arguments);
            };
          }();
          // LCP FID 需要事件输入才会触发回调
          window.addEventListener('mousedown', handleClick);
          window.addEventListener('keydown', handleClick);
        }
      }
      if (state === 'navigation') {
        if (curState === 'init') {
          // mock 首屏参数指标
          var fmpCallBack = function fmpCallBack(data) {
            task.finishState = 'fmp';
            console.log('finishCallBack', data.value);
            task.metrics['fmp'] = data.value;
            resolve(true);
          };
          // console.log('task.ctx.startTimestamp', task.ctx.startTimestamp)
          new FMPTiming({
            callback: fmpCallBack,
            startTime: task.ctx.startTimestamp
          });
        }
      }
    } catch (error) {
      reject(false);
    }
  });
};
var _startTask = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(task) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return waitTime();
        case 2:
          initBase(task);
          _context2.prev = 3;
          _context2.next = 6;
          return waitTriggerTask(task);
        case 6:
          _finish(task);
          _context2.next = 11;
          break;
        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](3);
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[3, 9]]);
  }));
  return function _startTask(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var _setMetrics = function _setMetrics(task, data) {
  // console.log('_setMetrics', task, data.type)

  if (!data.type) return;
  task.metrics[data.type] = data.value;
  return task;
};
var _normalizeParams = function _normalizeParams(task) {
  var params = task.params,
    metrics = task.metrics;
  Object.assign(params.backup, _objectSpread(_objectSpread({}, params.backup), metrics));
  // fix isFirst params 存到 sessionStorage 里面, fix cookie 过大
  // let loadcnt: number = getCookie(`${params.pagetype}-isindex`) || 0;
  // document.cookie = `${params.pagetype}-isindex=${++loadcnt}`;
  var loadcnt = +(sessionStorage.getItem("".concat(params.pagetype, "-isindex")) || 0);
  sessionStorage.setItem("".concat(params.pagetype, "-isindex"), String(++loadcnt));
  params.backup.isFirst = loadcnt > 1 ? 0 : 1;
  params.backup.loadcnt = loadcnt;
  task.metrics = {};
  // console.log('_normalizeParams', params, metrics)
  return params;
};
var _finish = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(task) {
    var _task$ctx, _task$ctx2;
    var data,
      spInfo,
      params,
      canSend,
      beforeSend,
      _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          data = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
          if (!task.isFinished) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return");
        case 3:
          task.isFinished = true;
          if ((_task$ctx = task.ctx) !== null && _task$ctx !== void 0 && (_task$ctx = _task$ctx.options) !== null && _task$ctx !== void 0 && _task$ctx.getPageInfoLazy) {
            initBase(task);
          }
          // console.log('_finish', task, data)

          if (Object.keys(data).length) {
            Object.assign(task, data);
          }

          // web-vital / performanceTiming / resource 等统计
          startPerformance(task);
          _context3.next = 9;
          return calcNetSpeed();
        case 9:
          spInfo = _context3.sent;
          _setMetrics(task, spInfo);
          params = _normalizeParams(task); // console.log('beforeSend', params, task);
          canSend = true;
          if (beforeSend = (_task$ctx2 = task.ctx) === null || _task$ctx2 === void 0 || (_task$ctx2 = _task$ctx2.options) === null || _task$ctx2 === void 0 ? void 0 : _task$ctx2.beforeSend) {
            canSend = beforeSend(params);
          }
          if (!(canSend === false)) {
            _context3.next = 16;
            break;
          }
          return _context3.abrupt("return");
        case 16:
          lego.send(_objectSpread({}, params));
        case 17:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function _finish(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
export var createTask = function createTask(ctx) {
  var _ctx = Object.assign({}, ctx);
  var task = {
    metrics: {},
    params: {
      backup: {}
    },
    finishState: '',
    isFinished: false,
    finish: function finish(data) {
      return _finish(task, data);
    },
    setMetrics: function setMetrics(data) {
      return _setMetrics(task, data);
    },
    options: _ctx.options,
    ctx: _ctx
  };
  _ctx.task = task;
  _startTask(task);
  return task;
};
export * from "./longtask";
export * from "./web-vitals";